import React from 'react';

import { hotspotMapMessages } from '../../../../../translates/hotspotMapMessages';
import { useIntlReexport } from '../../../../hooks/useIntlReexport';
import { ItemsCompletion } from '../../../tracking/models/ItemsCompletion';
import { Button, ButtonVariant, useToastNotifications } from '@ael/shared-components-library';
import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro';

type HotspotMapCounterButtonProps = {
  progress: ItemsCompletion;
};

export const HotspotMapCounterButton = ({ progress }: HotspotMapCounterButtonProps) => {
  const { addInfoToast } = useToastNotifications();
  const { formatMessage } = useIntlReexport();

  return (
    <div className="uno-fixed uno-top-5 uno-right-5">
      <Button
        icon={solid('location-dot')}
        variant={ButtonVariant.SECONDARY}
        onClick={() =>
          addInfoToast({
            darkMode: true,
            title: formatMessage(hotspotMapMessages.counterReveal),
            icon: regular('lightbulb'),
            id: 'hotspotMapCounterButton',
          })
        }
      >
        {progress.completedItemsCount}/{progress.itemsCount} {formatMessage(hotspotMapMessages.counterRemaining)}
      </Button>
    </div>
  );
};
